/**
 * typesafe version for growthbook.getFeatureValue
 * it's exported to growthbook.js to keep importing via ~/growthbook
 */

import { growthbook } from './growthbook';
import { WorkerClassificationTypeEnum } from './models';

type TStatesToShowBreakReminderV2 =
  | Record<string, Record<WorkerClassificationTypeEnum, number>>
  | undefined;
/**
 * return as json
 * e.g : {"FL": {"employee": 4, "contractor": 5}}
 */
export const getShouldUseStatesConfigToShowBreakReminder = () =>
  growthbook.getFeatureValue<TStatesToShowBreakReminderV2>(
    'TEMP-13149-states-config-to-show-break-reminder',
    undefined,
  );

type TStatesToShowBreakReminderCAV2 =
  | Record<
      WorkerClassificationTypeEnum,
      Record<
        | 'firstNotificationThresholdInMinutes'
        | 'firstNotificationTimeInMinutes'
        | 'secondNotificationThresholdInMinutes'
        | 'secondNotificationTimeInPercentage',
        number
      >
    >
  | undefined;
/**
 * return as json
 * e.g :
 * {
   "employee":{
      "firstNotificationThresholdInMinutes":210,
      "firstNotificationTimeInMinutes":119,
      "secondNotificationThresholdInMinutes":360,
      "secondNotificationTimeInPercentage":75
   },
   "contractor":{
      "firstNotificationThresholdInMinutes":210,
      "firstNotificationTimeInMinutes":119,
      "secondNotificationThresholdInMinutes":360,
      "secondNotificationTimeInPercentage":75
   }
  }
 */
export const getShouldUseStatesConfigToShowBreakReminderCA = () =>
  growthbook.getFeatureValue<TStatesToShowBreakReminderCAV2>(
    'TEMP-13149-states-config-to-show-break-reminder-ca',
    undefined,
  );
